import { useEffect, useState, useRef, useCallback } from "react";
import { getCurrentDagStatus } from "../../services/dag-status";

const DAG_ID = "Lastprice";

const useLastPriceStatusPolling = (intervalMs = 30000) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isOnline, setIsOnline] = useState(true);
  const intervalRef = useRef(null);
  const cancelledRef = useRef(false);

  const fetchStatus = useCallback(async () => {
    try {
      const response = await getCurrentDagStatus(DAG_ID);
      if (cancelledRef.current) return;
      const payload = response?.data?.data ?? null;
      setData(payload);
      setError(null);
      setIsOnline(true);
    } catch (err) {
      if (cancelledRef.current) return;
      setError(err);
      setIsOnline(false);
      // NO tocar `data`: preserva último estado conocido
    }
  }, []);

  useEffect(() => {
    cancelledRef.current = false;

    const startPolling = () => {
      fetchStatus(); // llamada inmediata al arrancar
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = setInterval(fetchStatus, intervalMs);
    };

    const stopPolling = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        startPolling();
      } else {
        stopPolling();
      }
    };

    // Arranque inicial solo si la pestaña está visible
    if (document.visibilityState === "visible") {
      startPolling();
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      cancelledRef.current = true;
      stopPolling();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [intervalMs, fetchStatus]);

  return { data, error, isOnline };
};

export default useLastPriceStatusPolling;
